import { useEffect } from 'react'

import type { TourStep } from './steps'
import { TourHighlight } from './TourHighlight'
import { TourStepCard } from './TourStepCard'
import type { TourStepActions } from './TourStepContent'
import { holeAround } from './tourBox'
import { useScrollIntoView } from './useScrollIntoView'
import { useTourTarget } from './useTourTarget'

interface ActiveTourStepProps extends TourStepActions {
  step: TourStep
  number: number
  total: number
  onMissing: () => void
}

export const ActiveTourStep = ({
  onMissing,
  ...cardProps
}: ActiveTourStepProps) => {
  const { box, isMissing } = useTourTarget(cardProps.step.target)
  const isSettled = useScrollIntoView(cardProps.step.target, box !== null)
  const hole = box && holeAround(box)

  useEffect(() => {
    if (isMissing) onMissing()
  }, [isMissing, onMissing])

  return (
    <>
      <TourHighlight hole={hole} />
      {hole && isSettled && <TourStepCard hole={hole} {...cardProps} />}
    </>
  )
}
